<template>
<div class="row">
    <div class="col-lg-12">
        <form class="py-4">
            <div class="form-group" v-if="!agency_id">
                <label for>Agency</label>
                <select
                    v-model="programme.agency_id"
                    class="form-control form-control-lg border-0 bg-gray"
                >
                    <option value>Select agency</option>
                    <option v-for="agency in agencies" :key="agency.id" :value="agency.id">{{ agency.name }}</option>
                </select>
            </div>
            <div class="form-group">
                <label for>Programme Name</label>
                <input
                    v-model="programme.name"
                    type="text"
                    class="form-control form-control-lg bg-gray border-0"
                />
            </div>
            <div class="form-group">
                <b-form-checkbox
                    v-model="programme.is_private"
                    :unchecked-value="false"
                >Is Private</b-form-checkbox>
                <small>Please tick this box if this is a private programme. Private programme is not open to public participants. An access code will be provided to the participants to take the test.</small>
            </div>
            <div class="form-group mb-3">
                <label for>Programme Description</label>
                <textarea v-model="programme.description" class="form-control bg-gray border-0" rows="4"></textarea>
            </div>
            <span>
                <div id="loc" v-for="(location, index) in programme.locations" :key="index">
                    <div class="p-4 border rounded mt-4">
                        <div class="form-group">
                            <a
                                @click="removeLocation(index)"
                                class="d-flex justify-content-end align-items-center pt-2"
                            >
                                <i class="las la-times"></i>
                            </a>
                            <label for>Programme Location</label>
                            <input type="text" readonly class="form-control-plaintext" :value="location.name" />
                        </div>

                        <div
                            v-for="(date, indexDate) in location.date"
                            :key="indexDate"
                            class="px-3 pb-2 rounded bg-gray-light mt-3"
                        >
                            <a
                                @click="removeDate(index, indexDate)"
                                class="d-flex justify-content-end align-items-center pt-2"
                            >
                            <i class="las la-times"></i>
                            </a>
                            <div class="form-group">
                                <div class="form-group row mb-0">
                                    <div class="col-lg-6">
                                        <label for>Start Date</label>
                                    </div>
                                    <div class="col-lg-6">
                                        <label for>End Date</label>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-lg-6">
                                    <input
                                        v-model="programme.locations[index].date[indexDate].started_at"
                                        type="date"
                                        class="form-control form-control-lg"
                                    />
                                    </div>
                                    <div class="col-lg-6">
                                    <input
                                        v-model="programme.locations[index].date[indexDate].ended_at"
                                        type="date"
                                        class="form-control form-control-lg"
                                    />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group mt-3 mb-0">
                            <button
                            type="button"
                            @click="createDate(index)"
                            class="btn btn-sm btn-add-date text-gray p-0"
                            >
                            <i class="fa fa-plus mr-2"></i>Add more date
                            </button>
                        </div>
                    </div>
                </div>

                <div class="mt-4">
                    <button type="button" class="btn btn-primary-outline" v-b-modal.modal-state>
                    <i class="fa fa-plus mr-2"></i>Add location
                    </button>
                </div>
            </span>
        </form>
        <div class="row mt-4 mb-5">
            <div class="col-lg-12">
                <div class="border-top d-flex justify-content-end pt-4">
                    <a :href="route('en.programmes.index')" class="btn btn-lg mr-3">Cancel</a>
                    <button
                    v-if="!edit"
                    @click="handleOk()"
                    type="button"
                    class="btn btn-primary btn-lg px-5"
                    >Add Programme</button>
                    <button
                    v-if="edit"
                    @click="handleOk()"
                    type="button"
                    class="btn btn-primary btn-lg px-5"
                    >Update Programme</button>
                </div>
            </div>
        </div>
    </div>

    <!-- modal -->
    <b-modal
    id="modal-state"
    title="Select Location"
    @ok="selectLocation"
    @hidden="resetLocationModal"
    >
    <form class="pb-5">
        <div class="form-group">
        <label for>Location</label>
        <select
            v-model="location_data_selected"
            class="form-control form-control-lg border-0 bg-gray"
        >
            <option value>Select location</option>
            <option
            v-for="location in locations"
            :key="location.id"
            :value="location"
            >{{ location.name }}</option>
        </select>
        </div>
    </form>
    </b-modal>
</div>
</template>

<script>
export default {
  props: ["edit", "agency_id", "programme_id"],
  data() {
    return this.initData();
  },
  mounted() {
    this.loadData();
    if (this.agency_id) {
      this.programme.agency_id = this.agency_id;
    }
  },
  methods: {
    initData() {
      return {
        programme: {
          agency_id: "",
          name: "",
          is_private: false,
          description: "",
          locations: []
        },
        removeSchedule: [],
        removeScheduleTime: [],
        agencies: [],
        locations: [],
        locationsSelected: [],
        location_data_selected: "",
        isEdit: false
      };
    },
    async loadProgramme() {
      try {
        const { data } = await axios.get(
          route("api.programmes.show", this.programme_id)
        );
        this.programme = data.data;
        this.programme.locations.forEach(location => {
          this.autoRemoveLoactionFromSelection(location.name);
        });
      } catch (e) {
        this.errorPopup(e.response.data.message);
      }
    },
    async loadData() {
      let loader = this.$loading.show();
      try {
        const [agencies, locations] = await Promise.all([
          axios.get(route("api.agencies.index")),
          axios.get(route("api.states.index"))
        ]);
        this.agencies = agencies.data;
        this.locations = locations.data;
        if (this.edit) {
          this.isEdit = true;
          this.loadProgramme();
          loader.hide();
        } else {
          loader.hide();
        }
      } catch (e) {
        console.log(e);
        loader.hide();
        this.errorPopup(e.response.data.message);
      }
    },
    handleOk() {
      if (this.isEdit) {
        this.submit_update();
      } else {
        this.submit_store();
      }
    },
    async submit_store() {
      console.log("submit");
      let loader = this.$loading.show();
      // this.$v.$touch();
      // if (this.$v.$invalid) {
      //     loader.hide();
      // } else {
      try {
        const { data } = await axios.post(route("api.programmes.store"), {
          programme: this.programme
        });
        // loader.hide();
        // this.successSwal();
        window.location.href = route("en.programmes.show", data.id);
      } catch (e) {
        console.log(e);
        loader.hide();
        this.errorPopup(e.response.data.message);
      }
      // }
    },
    async submit_update() {
      console.log("submit");
      let loader = this.$loading.show();
      // this.$v.$touch();
      // if (this.$v.$invalid) {
      //     loader.hide();
      // } else {
      try {
        const { data } = await axios.put(
          route("api.programmes.update", this.programme.id),
          {
            programme: this.programme,
            removeSchedule: this.removeSchedule,
            removeScheduleTime: this.removeScheduleTime
          }
        );
        loader.hide();
        this.successSwal();
      } catch (e) {
        console.log(e);
        loader.hide();
        this.errorPopup(e.response.data.message);
      }
      // }
    },
    autoRemoveLoactionFromSelection(name) {
      var dataLocationIndex = this.locations.findIndex(x => x.name === name);
      this.locationsSelected.push(this.locations[dataLocationIndex]);
      this.locations.splice(dataLocationIndex, 1);
    },
    selectLocation() {
      if (this.location_data_selected) {
        this.programme.locations.push({
          id: this.location_data_selected.id,
          name: this.location_data_selected.name,
          date: []
        });
        this.locationsSelected.push(this.location_data_selected);
        this.locations.splice(
          this.locations.indexOf(this.location_data_selected),
          1
        );
      }
    },
    removeLocation(index) {
      var dataLocationIndex = this.locationsSelected.findIndex(
        x => x.name === this.programme.locations[index].name
      );

      if (this.isEdit) {
        if (this.programme.locations[index].id) {
          this.removeSchedule.push(this.programme.locations[index]);
        }
      }

      this.programme.locations.splice(index, 1);
      this.locations.push(this.locationsSelected[dataLocationIndex]);
      this.locationsSelected.splice(dataLocationIndex, 1);
    },
    resetLocationModal() {
      this.location_data_selected = "";
    },
    createDate(index) {
      var data = {
        started_at: null,
        ended_at: null
      };
      this.programme.locations[index].date.push(data);
    },
    removeDate(index, indexDate) {
      if (this.isEdit) {
        if (this.programme.locations[index].date[indexDate].id) {
          this.removeScheduleTime.push(
            this.programme.locations[index].date[indexDate]
          );
        }
      }
      this.programme.locations[index].date.splice(indexDate, 1);
    }
  }
};
</script>
